import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { Toaster } from 'react-hot-toast';
import { MantineProvider } from "@mantine/core";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <MantineProvider>
      <App />
    </MantineProvider>
    {/* <Toaster position="top-center" /> */}

    <Toaster
      position="top-center"
      toastOptions={{
        error: {
          style: {
            background: "#dc2626",
            color: "#fff",
          },
        },
        success: {
          style: {
            background: "#16a34a",
            color: "#fff",
          },
        },
      }}
    />

  </Provider>


);

{/* <React.StrictMode>
    <Provider store={store}>
      <App />
      <Toaster position="top-center" />
    </Provider>
  </React.StrictMode> */}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
